import { useParams } from "react-router-dom";
import CreateOrEditScenarioDialog, {
  ScenarioSubmitPayload,
} from "./CreateOrEditScenarioDialog";
import { useState } from "react";
import { useEstimateInfo } from "../hooks/useScenarioStore";
import { useCreateProjectGroupsScenarios } from "@/libs/react-query/hooks/useScenarioQuery";
import { formatScenarioRequestData } from "../utils";

export default function ScenarioCreateHeaderButton() {
  const { group_id = "" } = useParams();
  const [createDialogOpen, setCreateDialogOpen] = useState(false);

  const estimateInfo = useEstimateInfo();
  const { mutate: createScenario } = useCreateProjectGroupsScenarios(group_id);

  const handleCreate = (data: ScenarioSubmitPayload) => {
    if (!data?.divisions || !estimateInfo) {
      return null;
    }
    const { projectId, projectType } = estimateInfo;
    const { latestSheetId, title, divisions } = data;
    const formattedData = formatScenarioRequestData(divisions);

    try {
      createScenario(
        {
          project_id: projectId,
          project_type: projectType,
          title,
          ref_item_sheet_id: latestSheetId,
          data: formattedData,
        },
        {
          onSuccess: () => {
            setCreateDialogOpen(false);
          },
        }
      );
    } catch (error) {
      console.error("Error creating scenario:", error);
    }
  };

  return (
    <CreateOrEditScenarioDialog
      mode="create"
      open={createDialogOpen}
      setOpen={setCreateDialogOpen}
      onSubmit={handleCreate}
    />
  );
}
